export const qrGatewayPath = (quantity: string): string => {
  return `/gateways/generate-qr-codes/${quantity}`;
};

export const assignGatewayPath = (gatewayQid: string, assetId: string): string => {
  return `/assets/${assetId}/gateways/${gatewayQid}`;
};
